import { ANY, GUEST } from '@core/roles/SalesPortalRoles.js';
import { hasValue } from '@helpers/utils/utils.js';

export const RoleService = {
  hasRole: (roles, needCheckRoles) => {
    if (roles.length === 0 || roles.includes(ANY) || roles.includes(GUEST)) {
      return true;
    }
    return (
      needCheckRoles &&
      needCheckRoles.some(
        (e) =>
          hasValue(e) &&
          roles.some((reg) => hasValue(reg) && e.match(reg) !== null),
      )
    );
  },
  getChannelFromRoles: (needCheckRoles, channelMap) => {
    const channels = [];
    if (
      needCheckRoles.length === 0 ||
      needCheckRoles.includes(ANY) ||
      needCheckRoles.includes(GUEST)
    ) {
      return null;
    }

    for (const [key, val] of Object.entries(channelMap)) {
      const check = needCheckRoles.some((e) =>
        val.some((reg) => e.match(reg) !== null),
      );
      if (check) channels.push(key);
    }
    return channels.length > 0 ? channels[0] : null;
  },
  getProfileCodeFromRoles: (needCheckRoles, profileCodeMap) => {
    const profileCodes = [];
    if (
      needCheckRoles.length === 0 ||
      needCheckRoles.includes(ANY) ||
      needCheckRoles.includes(GUEST)
    ) {
      return null;
    }

    for (const [key, val] of Object.entries(profileCodeMap)) {
      const check = needCheckRoles.some((e) =>
        val.some((reg) => e.match(reg) !== null),
      );
      if (check) profileCodes.push(key);
    }
    return profileCodes.length > 0 ? profileCodes[0] : null;
  },
  specialCheck: (condition, isHousehold, selectedProfiles) => {
    if (condition === 'household') {
      if (isHousehold) {
        return true;
      }
      return selectedProfiles.some((profile) => profile.includes('ACB_CHNL'));
    }
    return true;
  },

  rolesBasedAccessControl(rolesNeedToChecking, roles) {
    return this.fnCompareRole(rolesNeedToChecking, roles);
  },

  fnCompareRole(rolesNeedToChecking, rolesCurrentActive) {
    const arrayChecking = [];

    rolesNeedToChecking.forEach((rolesPattern) => {
      const patternRegex = new RegExp(rolesPattern);
      rolesCurrentActive.forEach((rolesActive) => {
        arrayChecking.push(patternRegex.test(rolesActive));
      });
    });

    if (arrayChecking && arrayChecking.length) {
      return arrayChecking.some((hasRole) => hasRole === true);
    }
  },
};
